<div class="col-xs-12">
    <h3>Gerenciar editais de prestação de contas</h3>
    <hr>


    <div class="col-sm-6 no-padding">
        <form autocomplete="off" (ngSubmit)="pesquisar()" *ngIf="auth.temPermissao('ROLE_PESQUISAR_CONCEDENTE')">
            <div class="input-group input-group-sm">
                <input type="text" style="border-radius: 3px 0 0 3px !important;" class="form-control" name="nome"
                    placeholder="Pesquisar por nome" [(ngModel)]="filtro.et1Titulo">
                <span class="input-group-btn">
                    <button type="submit" class="btn btn-primary ">
                        <i class="fa fa-search"></i>
                    </button>
                </span>
            </div>
                    <div class="form-group col-sm-12 no-padding" style="margin-top: 8px;">
                <label class="checkbox-inline">
                    <input type="checkbox" [(ngModel)]="manterFiltrosSelecionados" name="manterFiltrosSelecionados"
                        (ngModelChange)="alterarManterFiltrosSelecionados($event)">
                    Manter filtros selecionados
                </label>
            </div></form>
    </div>


    <br>
    <br>
    <br>

      
    <!-- <div *ngIf="!loading"> -->
    <div *ngIf="!telaInicializada || loading">
        <div class="spinner"></div>
        <p class="text-center" style="color: #777;margin: -70px 0 100px;">Carregando solicitação, por
            favor aguarde ...</p>
    </div>

    <!-- <div *ngIf="loading"> -->
    <div *ngIf="telaInicializada && !loading">

        <!--NENHUM REGISTRO ENCONTRADO-->
        <div class="col-sm-12 no-padding" *ngIf="celebracaoLista.length == 0">
            <h4 class="text-muted">Nenhum registro encontrado.</h4>
        </div>
        <div class="col-sm-12 no-padding" *ngIf="celebracaoLista.length > 0">
                <table class="table table-striped">
                    <tbody>
                        <tr>
                            <th>Título</th>
                            <th>Tipo</th>
                            <th>Entidade concedente</th>
                            <th class="text-center">Data término</th>
                            <th class="text-center">Ação</th>
                        </tr>
                        <tr *ngFor="let item of celebracaoLista">
                            <td>{{ item.et1Titulo }}</td>
                            <td>{{ retornaTipoCelebracao(item) }}</td>
                            <td>{{ item.et1EntidadeConcedente.nome }}</td>
                            <td class="text-center">{{ item.et5PeriodoFimExecucao | date: 'dd/MM/yyyy' }}</td>
                            <td class="text-center">
                                <span class="badge bg-blue cursor" pTooltip="Visualizar" tooltipPosition="top" (click)="gotoExecucaoVisualizar(item)">
                                    <i class="fa fa-fw fa-eye"></i>
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <pagination [page]="page" (paginationEvent)=changePage($event)></pagination>
        </div>

    </div>
</div>
